<style>
  .ivu-table .demo-table-error-row td{
    background-color: #f6caca;
  }
</style>
<template>
  <div class="git-list">
     <Modal title="搜索条件" v-model="searchConditionModal" width="600">
      <Form label-position="top">
        <FormItem label="条件">
          <CheckboxGroup v-model="condition" @on-change="conditionChange">
            <Checkbox label="域名"></Checkbox>
            <Checkbox label="所属平台"></Checkbox>
            <Checkbox label="平台账号"></Checkbox>
            <Checkbox label="分组"></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem :label="key" v-for="(data, key, idx) in conditionObjects" :key="idx">
          <Input v-if="key === '分组'" v-model="data.value" placeholder="请输入关键词">
           <Select v-model="data.rule" slot="prepend" style="width: 80px" placeholder="匹配规则">
              <Option value="contain">包含</Option>
            </Select>
          </Input>
          <Select v-if="key !== '分组'"  v-model="data.rule" style="width: 80px">
            <Option value="contain">等于</Option>
          </Select>
          <Select v-if="key === '域名'" v-model="data.value" style="width: 480px" filterable multiple>
            <Option v-for="(item, index) in allDomains" :value="item" :key="index">{{ item }}</Option>
          </Select>
           <Select v-if="key === '所属平台'" v-model="data.value" style="width: 480px" filterable multiple>
            <Option v-for="(item, index) in allPlatforms" :value="item" :key="index">{{ item }}</Option>
          </Select>
          <Select v-if="key === '平台账号'" v-model="data.value" style="width: 480px" filterable multiple>
            <Option v-for="(item, index) in allAccounts" :value="item" :key="index">{{ item }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button style="float: left" @click="searchConditionClear">清空</Button>
        <!-- <Poptip placement="top" width="200">
          <Button type="text" style="color: #2d8cf0">另存为</Button>
          <div class="api" slot="content">
            <div style="padding-bottom: 5px">保存收藏条件：</div>
            <Input v-model="containName" size="small" placeholder="请填写名称"/>
            <div style="float: right; margin-top:5px;">
              <Button type="primary" @click="conditionSave" size="small">保存</Button>
            </div>
          </div>
        </Poptip> -->
        <!-- <Button type="text" style="color: #2d8cf0" @click="conditionSave" :disabled="this.containName ? false : true">保存</Button> -->
        <Button type="primary" style="margin-left:5px;"  @click="search">查询</Button>
      </div>
    </Modal>
    <Row class="" style="border-radius: 4px">
      <Col style="border-left: 6px solid #f5f7f9;">
        <Card shadow>
            <Row class="sm-pc-w100">
              <Col>
                <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent>
                  <!-- <FormItem label="域名名称">
                    <Input v-model="tableSearchForm.name" style="width: 200px" />
                  </FormItem> -->
                  <FormItem :label-width="0" class="mob-align-right">
                     <Tag v-for="(data, key, idx) in conditionObjects" :key="idx" :name="key" closable @on-close="handleClose" @click.native="tagClick">{{ data.rule === 'no_equal' ? '非 ' : '' }}{{ key }}: {{ dealShowName(data.value, key) }}</Tag>
                    <Tooltip content="筛选" style="margin-right:5px;">
                      <Button icon="ios-funnel" @click="searchConditionModifyOpen"></Button>
                    </Tooltip>
                    <Button type="primary" style="margin-left:5px;margin-right:5px;"  @click="search">查询</Button>
                    <!-- <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button> -->
                    <Button style="margin-left: 8px" @click="SyncDomain" :loading="loadingSync">同步域名</Button>
                    <!-- <Button style="margin-left: 8px" @click="SyncCost">同步费用</Button> -->
                  </FormItem>
                  <Checkbox style="margin-top: 10px;float: right" v-model="deleteFlag" @on-change="showDeleteChange">显示已删除的域名</Checkbox>
                </Form>
              </Col>
            </Row>
            <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
            <Table
              v-else
              border
              highlight-row
              :loading="tableLoading"
              :row-class-name="rowClassName"
              ref="table"
              :data="table.data"
              :columns="table.columns"
              @on-sort-change="changeSort"></Table>
            <div style="margin: 10px 0; overflow: hidden;">
              <div style="float: left;">
                当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
              </div>
              <div style="float: right;">
                <page
                  :total="table.count"
                  :current="table.page"
                  :page-size="table.size"
                  @on-change="getTableData"></page>
              </div>
            </div>
        </Card>
      </Col>
   </Row>
  </div>
</template>

<script>
import { getServerCostProductMon, getServerCostPlatformMon, SyncDomain, SyncCost, getDomainAccount, getDomainLst, getDomainPlatform, getDomainExpire, getServerAccount,
  getServerExpire, getServerPlatform, getServerOs, getServerType, getServerRegion, getServerCostPlatform, getServerCostAccount, getServerCostProduct, getAllDomains, getAllDomainAccounts } from '@/api/opscenter'
import { getAssetsType, getAssetsStatus, getAssetsStatusTime } from '@/api/cmdb'
import { getCodeReleaseProjectMon, getCodeReleaseProjectTop, getCodeReleaseStatus } from '@/api/workflow/code_release_flow'
import { getDbType, getDbInstance, getDbMon, getDbShowStatus, getDbTop } from '@/api/workflow/db_release_flow'
import { getMigrateMon, getMigrateTop, getMigrateShowStatus } from '@/api/workflow/db_data_migrate_flow'
import Vue from 'vue'
export default {
  data () {
    let that = this
    return {
      loadingSync: false,
      searchConditionModal: false,
      currentSearchCondition: '',
      searchConditions: [],
      condition: [],
      conditionObjects: {},
      deleteFlag: false,
      allPlatforms: ['aliyun', 'godaddy', 'west'],
      allDomains: [],
      allAccounts: [],
      status: null,
      ordering: null,
      loadingConfig: false,
      loadingCheck: false,
      selectObj: [],
      selectRow: [],
      defaultDomains: ['us', 'ca', 'de', 'fr', 'uk', 'es', 'it', 'jp'],
      selectNodes: [],
      nodeListSpan: 4,
      contentSpan: 20,
      nodesList: [],
      nodeListShow: true,
      groupId: null,
      node: null,
      tableLoading: false,
      tableSearchForm: {
        name: '',
        registrar: '',
        username: '',
        groups: ''
      },
      table: {
        data: [],
        columns: [
          {
            title: '名称',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 200
          },
          {
            title: '状态',
            key: 'DomainStatus',
            align: 'center',
            minWidth: 200,
            sortable: 'custom',
            render: (h, params) => {
              const row = params.row
              const color = row.status === 'expired' ? 'error' : 'success'
              const text = row.status === 'expired' ? '已过期' : '正常'
              // 未安装， 正常， 异常
              return h('Tag', {
                props: {
                  type: 'dot',
                  color: color
                }
              }, text)
            },
            filters: [
              {
                label: '正常',
                value: 'normal'
              },
              {
                label: '已过期',
                value: 'expired'
              }
            ],
            filterMultiple: false,
            filterRemote (value, row) {
              if (value.length > 0) {
                that.status = value[0]
              } else {
                that.status = null
              }
              that.getTableData()
            }
          },
          {
            title: '所属平台',
            key: 'registrar',
            align: 'center',
            tooltip: true,
            minWidth: 250,
            sortable: 'custom'
          },
          {
            title: '所属平台账号',
            key: 'username',
            align: 'center',
            tooltip: true,
            minWidth: 250
          },
          {
            title: '注册时间',
            key: 'time_register',
            align: 'center',
            tooltip: true,
            minWidth: 250,
            sortable: 'custom'
          },
          {
            title: '过期时间',
            key: 'time_expire',
            align: 'center',
            tooltip: true,
            minWidth: 250,
            sortable: 'custom'
          },
          {
            title: '分组',
            key: 'groups',
            align: 'center',
            tooltip: true,
            minWidth: 250,
            sortable: 'custom'
          },
          {
            title: '备注',
            key: 'remark',
            align: 'center',
            tooltip: true,
            minWidth: 250
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      listError: false
    }
  },
  created: function () {
  },
  mounted () {
    this.getTableData()
    this.getAllDomains()
    this.getAllDomainAccounts()
  },
  methods: {
    showDeleteChange () {
      this.getTableData()
    },
    dealShowName (value, key) {
      // contain  equal  no_equal
      console.log(value)
      if (value !== '') {
        if (key === '域名' || key === '所属平台' || key === '平台账号') {
          return value.join(',')
        } else {
          return value
        }
      } else {
        return ''
      }
    },
    tagClick () {
      this.searchConditionModifyOpen()
    },
    handleClose (event, name) {
      console.log(name)
      // delete this.conditionObjects[name]
      // Vue.delete 可以触发视图更新, delete不会
      Vue.delete(this.conditionObjects, name)
      // 同时要删掉checkBox 勾选状态
      this.condition = Object.keys(this.conditionObjects)
      this.conditionSearch()
    },
    searchConditionModifyOpen () {
      this.searchConditionModal = true
    },
    search () {
      this.searchConditionModal = false
      this.conditionSearch()
    },
    dealValue (item, key) {
      // contain  equal  no_equal
      if (item) {
        if (item['rule'] === 'contain') {
          if (key === '域名' || key === '所属平台' || key === '平台账号') {
            return item['value'].join(',')
          } else {
            return item['value']
          }
        } else if (item['rule'] === 'no_equal') {
          // return 'NOT-' + item['value'].toString()
        } else {
        }
      } else {
        return ''
      }
    },
    conditionSearch () {
      // 触发日志查询方法
      let obj = this.conditionObjects
      this.tableSearchForm.name = this.dealValue(obj['域名'], '域名')
      this.tableSearchForm.registrar = this.dealValue(obj['所属平台'], '所属平台')
      this.tableSearchForm.username = this.dealValue(obj['平台账号'], '平台账号')
      this.tableSearchForm.groups = this.dealValue(obj['分组'], '分组')
      this.getTableData()
    },
    searchConditionClear () {
      this.condition = []
      this.conditionChange([])
    },
    conditionChange (conditions) {
      let mConditions = JSON.parse(JSON.stringify(conditions))
      let conditionObjects = JSON.parse(JSON.stringify(this.conditionObjects))
      for (let i in conditionObjects) {
        let idx = mConditions.indexOf(i)
        if (idx > -1) {
          mConditions.splice(idx, 1)
        } else {
          delete (this.conditionObjects[i])
        }
      }
      for (let i in mConditions) {
        this.conditionObjects[mConditions[i]] = {
          rule: 'contain',
          value: ''
        }
      }
    },
    getAllDomains () {
      getAllDomains().then(res => {
        this.allDomains = res.data
      }).catch(res => {
      })
    },
    getAllDomainAccounts () {
      getAllDomainAccounts().then(res => {
        this.allAccounts = res.data
      }).catch(res => {
      })
    },
    getServerAccount () {
      let params = {
        time: 30
      }
      getServerAccount(params).then(res => {
      }).catch(res => {
      })
    },
    SyncDomain () {
      this.loadingSync = true
      SyncDomain().then(res => {
        this.loadingSync = false
        this.$Message.success('同步成功')
      }).catch(res => {
      })
    },
    SyncCost () {
      SyncCost().then(res => {
      }).catch(res => {
      })
    },
    getMigrateShowStatus () {
      getMigrateShowStatus().then(res => {
      }).catch(res => {
      })
    },
    getMigrateTop () {
      getMigrateTop().then(res => {
      }).catch(res => {
      })
    },
    getMigrateMon () {
      let params = {
        start_date: '2018-11',
        end_date: '2019-12',
        project: 2
      }
      getMigrateMon(params).then(res => {
      }).catch(res => {
      })
    },
    getDbShowStatus () {
      getDbShowStatus().then(res => {
      }).catch(res => {
      })
    },
    getDbMon () {
      let params = {
        start_date: '2018-11',
        end_date: '2019-12',
        project: 2
      }
      getDbMon(params).then(res => {
      }).catch(res => {
      })
    },
    getDbTop () {
      getDbTop().then(res => {
      }).catch(res => {
      })
    },
    getDbInstance () {
      getDbInstance().then(res => {
      }).catch(res => {
      })
    },
    getDbType () {
      getDbType().then(res => {
      }).catch(res => {
      })
    },
    getCodeReleaseStatus () {
      let params = { project: 2 }
      getCodeReleaseStatus(params).then(res => {
      }).catch(res => {
      })
    },
    getCodeReleaseProjectTop () {
      getCodeReleaseProjectTop().then(res => {
      }).catch(res => {
      })
    },
    getCodeReleaseProjectMon () {
      let params = {
        start_date: '2018-11',
        end_date: '2019-12',
        project: 2
      }
      getCodeReleaseProjectMon(params).then(res => {
      }).catch(res => {
      })
    },
    getDomainExpire () {
      let params = {
        ordering: 'time_expire',
        time: 30
      }
      getDomainExpire(params).then(res => {
      }).catch(res => {
      })
    },
    getDomainPlatform () {
      getDomainPlatform().then(res => {
      }).catch(res => {
      })
    },
    getDomainAccount () {
      let params = {
        time: 30
      }
      getDomainAccount(params).then(res => {
      }).catch(res => {
      })
    },
    getServerExpire () {
      let params = {
        ordering: 'time_expire',
        time: 30
      }
      getServerExpire(params).then(res => {
      }).catch(res => {
      })
    },
    getServerPlatform () {
      getServerPlatform().then(res => {
      }).catch(res => {
      })
    },
    getServerOs () {
      getServerOs().then(res => {
      }).catch(res => {
      })
    },
    getServerType () {
      getServerType().then(res => {
      }).catch(res => {
      })
    },
    getServerRegion () {
      let params = {
        platform: 1
      }
      getServerRegion(params).then(res => {
      }).catch(res => {
      })
    },
    // 费用api测试
    getServerCostPlatform () {
      console.log(11111111111111)
      let params = {
        start_date: '2018-01',
        end_date: '2019-12'
      }
      getServerCostPlatform(params).then(res => {
      }).catch(res => {
      })
    },
    getServerCostAccount () {
      let params = {
        start_date: '2018-01',
        end_date: '2019-12'
      }
      getServerCostAccount(params).then(res => {
      }).catch(res => {
      })
    },
    getServerCostProduct () {
      let params = {
        start_date: '2018-01',
        end_date: '2019-12',
        support: 1,
        username: 'geandaali'
      }
      getServerCostProduct(params).then(res => {
      }).catch(res => {
      })
    },
    getServerCostProductMon () {
      let params = {
        start_date: '2018-01',
        end_date: '2019-12',
        support: 8,
        username: 'aenjoy'
      }
      getServerCostProductMon(params).then(res => {
      }).catch(res => {
      })
    },
    getServerCostPlatformMon () {
      let params = {
        start_date: '2019-01',
        end_date: '2019-10'
      }
      getServerCostPlatformMon(params).then(res => {
      }).catch(res => {
      })
    },
    // cmdb 资产api测试 getAssetsType, getAssetsStatus, getAssetsStatusTime
    getAssetsType () {
      getAssetsType().then(res => {
      }).catch(res => {
      })
    },
    getAssetsStatus () {
      let params = {
        start_date: new Date('2019-11-25').getTime() / 1000,
        end_date: new Date('2019-12-05').getTime() / 1000
      }
      getAssetsStatus(params).then(res => {
      }).catch(res => {
      })
    },
    getAssetsStatusTime () {
      let params = {
        start_date: '2018-12-10',
        end_date: '2019-12-10'
      }
      getAssetsStatusTime(params).then(res => {
      }).catch(res => {
      })
    },
    rowClassName (row, index) {
      if (row.time_expire) {
        let timeExpire = new Date(row.time_expire)
        let current = new Date()
        current.setDate(current.getDate() + 30)
        if (timeExpire.getTime() < current.getTime()) {
          // console.log(row.name)
          return 'demo-table-error-row'
        }
      }
      return ''
    },
    changeSort (column) {
      if (column.key === 'registrar') {
        if (column.order === 'asc') {
          this.ordering = 'registrar'
        } else {
          this.ordering = '-registrar'
        }
      } else if (column.key === 'time_register') {
        if (column.order === 'asc') {
          this.ordering = 'time_register'
        } else {
          this.ordering = '-time_register'
        }
      } else if (column.key === 'time_expire') {
        if (column.order === 'asc') {
          this.ordering = 'time_expire'
        } else {
          this.ordering = '-time_expire'
        }
      } else if (column.key === 'status') {
        if (column.order === 'asc') {
          this.ordering = 'status'
        } else {
          this.ordering = '-status'
        }
      } else if (column.key === 'groups') {
        if (column.order === 'asc') {
          this.ordering = 'groups'
        } else {
          this.ordering = '-groups'
        }
      }
      this.getTableData()
    },
    init (value) {
      this.getTableData()
    },
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      this.tableSearchForm['size'] = this.table.size
      this.tableSearchForm['page'] = this.table.page
      this.tableSearchForm['search'] = this.tableSearchForm.name
      this.tableSearchForm['ordering'] = this.ordering
      this.tableSearchForm['status'] = this.status
      if (!this.deleteFlag) {
        this.tableSearchForm['deleted'] = this.deleteFlag
      } else {
        this.tableSearchForm['deleted'] = null
      }
      getDomainLst(this.tableSearchForm).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        // console.log(res.response)
        this.listError = true
      })
    }
  }
}
</script>

<style scoped>

</style>
